module.exports = __webpack_public_path__ + "static/media/elasticsearch.f9786483.svg";